import axios from 'axios';

/**
 * Extract a user-friendly error message from an API error.
 * Works with Axios errors, standard Error objects, and unknown types.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
    if (axios.isAxiosError(error)) {
        const detail = error.response?.data?.detail;
        if (typeof detail === 'string') return detail;
        if (Array.isArray(detail)) {
            return detail
                .map((d: Record<string, unknown>) => (d?.msg as string) || JSON.stringify(d))
                .join('; ');
        }
        return fallback;
    }
    if (error instanceof Error) return error.message;
    return fallback;
}
